import React from 'react';
import { DiamondIcon, StarIcon, WrenchIcon } from 'lucide-react';
import { yearPlan } from '../data/content';
import { SectionHeading } from './SectionHeading';

/** One color per quarter (full class names so Tailwind keeps them). Dark text on coral and yellow for contrast. */
const quarterStyles = [{
  band: 'bg-brand text-white',
  star: 'text-brand'
}, {
  band: 'bg-coral text-ink',
  star: 'text-coral-ink'
}, {
  band: 'bg-violet text-white',
  star: 'text-violet-ink'
}, {
  band: 'bg-sun text-ink',
  star: 'text-ink'
}];

/** The 52-week plan, quarter by quarter: ★ program starts and ◆ progress reviews */
export function YearPlanSection() {
  return <section id="year" aria-labelledby="year-title" className="scroll-mt-4 bg-white py-12 md:py-20" data-id="element-250" data-mp="32jc3oif6sfl8">
      <div className="mx-auto max-w-page px-5 md:px-8" data-id="element-251" data-mp="37dq5b2kfziyc">
        <SectionHeading id="year-title" eyebrow={yearPlan.eyebrow} title={yearPlan.title} sub={yearPlan.sub} data-id="element-252" data-mp="29vq0vcds9ezf" />

        <ol className="mt-8 grid gap-4 md:mt-12 md:grid-cols-2 lg:grid-cols-4" data-id="element-253" data-mp="2etzyruqw6toq">
          {yearPlan.quarters.map((q, qi) => {
          const s = quarterStyles[qi % quarterStyles.length];
          return <li key={q.q} className="flex flex-col overflow-hidden rounded-xl border border-hair bg-white" data-id="element-254" data-mp="1vcr42y2aeoms" data-mpi={qi}>
                <div className={`flex items-baseline justify-between gap-3 px-5 py-3 ${s.band}`} data-id="element-255" data-mp="1qhl9zbyqe3nm">
                  <span className="font-display text-[1.6rem] font-black leading-none" data-id="element-256" data-mp="1lj0hxztmuqa9">{q.q}</span>
                  <span className="font-display text-[12px] font-extrabold tracking-[0.1em]" data-id="element-257" data-mp="1gjdvczrwzxos">{q.weeks}</span>
                </div>
                <div className="flex flex-1 flex-col p-5" data-id="element-258" data-mp="17kk2nkhpfrgi">
                  <h3 className="font-display text-[16px] font-black tracking-[0.04em] text-ink" data-id="element-259" data-mp="17n6all8ic8z9">{q.name}</h3>
                  <ul className="mt-4 space-y-3" data-id="element-260" data-mp="12obs6kegcmfo">
                    {q.full.map(m => {
                  const review = 'review' in m && m.review;
                  const Icon = review ? DiamondIcon : StarIcon;
                  return <li key={`${q.q}-${m.week}`} className="flex gap-3" data-id="element-261" data-mp="3g3tptprs7wfm">
                          <Icon className={`mt-0.5 h-4 w-4 shrink-0 fill-current ${review ? 'text-leaf-ink' : s.star}`} aria-hidden="true" data-id="element-262" data-mp="3kvlefurdns34" />
                          <div className="min-w-0" data-id="element-263" data-mp="375rp7bbyn5sv">
                            <p className="text-[11px] font-bold tracking-[0.1em] text-ink/55" data-id="element-264" data-mp="3c28ggeegi0a6">
                              WEEK {m.week} · {m.label}
                            </p>
                            <p className={`font-display text-[15px] font-bold leading-snug ${review ? 'text-leaf-ink' : 'text-brand'}`} data-id="element-265" data-mp="7ojpam3jiz9y">{m.title}</p>
                          </div>
                        </li>;
                })}
                  </ul>
                  <p className="mt-auto pt-4 text-[14px] leading-snug text-ink/70" data-id="element-266" data-mp="3uvcbo47bol6w">{q.activities}</p>
                </div>
              </li>;
        })}
        </ol>

        <div className="mx-auto mt-6 max-w-[900px] rounded-xl bg-sun-soft p-5 md:mt-8 md:p-6" data-id="element-267" data-mp="2jfnphf1w7q75">
          <div className="flex items-center gap-3" data-id="element-268" data-mp="2bta6g8x5k3k1">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-sun text-ink" data-id="element-269" data-mp="26w9w3lt9sen4">
              <WrenchIcon className="h-4 w-4" strokeWidth={2.5} aria-hidden="true" data-id="element-270" data-mp="2kvrpyflfai3c" />
            </span>
            <h3 className="font-display text-[14px] font-black tracking-[0.08em] text-ink" data-id="element-271" data-mp="2fw6s68hzofs7">{yearPlan.toolsTitle}</h3>
          </div>
          <ul className="mt-4 grid gap-2.5 md:grid-cols-3 md:gap-4" data-id="element-272" data-mp="1s7dua6ht3xuy">
            {yearPlan.tools.map(t => <li key={t} className="rounded-lg bg-white px-4 py-3 text-[15px] font-medium leading-snug text-ink" data-id="element-273" data-mp="1o3619x4bfvqx">
                {t}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}